module.exports = __webpack_public_path__ + "img/antes_despues_43.43a12afd.png";